// extracted by mini-css-extract-plugin
export default {"tags":"FeedCardTags_tags__hOeiz","tags__item":"FeedCardTags_tags__item__3dxiW"};